(function () {
  "use strict";

  angular
    .module("fleetviewApp")
    .controller("mapController", mapController);
  mapController.$inject = ["$rootScope", "$scope", "$timeout", "mapService", "$state", "LayoutService"];

  function mapController($rootScope, $scope, $timeout, mapService, $state, LayoutService) {
    var vm = this;
    var resizeTimeout;

    vm.canEdit = function () {
      return true;
    };

    vm.leftPanelWidth = function () {
      return LayoutService.getLeftPanelWidth();
    };
    vm.hidePanel = function(){
      if (!vm.isleftPanelHidden) {
        vm.isleftPanelHidden = true;
        LayoutService.closeLeftHandPanel();
        
      }
      else {
        vm.isleftPanelHidden = false;
        LayoutService.openLeftHandPanel(500);
        
      }
    }

    vm.locationText = "";
    vm.mapMessage = {
      show: false,
      txt: "",
      showMsg: function () {
        return vm.show;
      }
    };
    vm.mapObj = function () {
      return mapService.getMap();
    };
    vm.mapTooltip = {
      show: false,
      txt: "",
      labelClass: "info"
    };
    vm.showLoading = function () {
      return false;
    };
    vm.zoomToEdit = function () {
      mapService.zoomTo(16);
    };

    ///////////////////

    function init() {
      var that = vm;
    }

    function updateConstants() {
      var that = vm;
    }

    $rootScope.$watch("userInfo.dataVersion", function (n, o) {
      if (angular.equals(n, o)) {
        return;
      }
    });

    $scope.$on("mapMsg", function (event, msg) {
      $scope.mapMessage.show = msg.show;
      $scope.mapMessage.txt = msg.txt;
      if (!$scope.$$phase) $scope.$apply();
    });

    $scope.$on("tooltipMsg", function (event, msg) {
      $scope.mapTooltip.labelClass = msg.labelClass;
      $scope.mapTooltip.txt = msg.txt;
      $scope.mapTooltip.show = msg.show;
      if (!$scope.$$phase) $scope.$apply();

      if (msg.show === true) {
        var mouseFollow = function (e) {
          //find X & Y coordinates
          var x = e.clientX,
            y = e.clientY,
            tooltipSpan = document.getElementById("map-cursor-tooltip");
          //Set tooltip position according to mouse position
          tooltipSpan.style.top = (y - 80) + "px";
          tooltipSpan.style.left = (x + 20) + "px";
        };
        $(document).mousemove(mouseFollow);
      } else {
        $(document).off("mousemove", mouseFollow);
      }
    });

    $scope.$watch(() => LayoutService.getLeftPanelWidth(), (newValue) => {
      $timeout.cancel(resizeTimeout);

      resizeTimeout = $timeout(() => mapService.resizeMap(), 400);
    });

  }
})();



// WEBPACK FOOTER //
// ./app/map/map.controller.js